import React from "react";
import banner10 from "../assets/banner10.jpg"; // reuse banner4 or replace with a relevant image

export default function MappingDevelopmentCooperation() {
  return (
    <section className="py-5">

      {/* Heading */}
      <div className="text-center mb-3">
        <h2 className="main-section-title fw-bold">Mapping Studies & Development Cooperation</h2>
        <p className="text-muted small">
          Analysing sectors, stakeholders, and partnerships to guide development priorities.
        </p>
      </div>

      {/* Image */}
      <div className="mb-4">
        <img 
          src={banner10} 
          alt="Mapping Studies & Development Cooperation" 
          className="img-fluid rounded w-100"
        />
      </div>

      {/* Elaborative Text */}
      <div className="container">
        <p className="text-muted fs-6">
          Zamani Sabios Group supports organisations with sector mapping, stakeholder 
          analysis, and development cooperation strategies. Our services help identify 
          priorities, partnerships, and operational frameworks that strengthen institutional 
          performance and collaboration. We provide evidence-based recommendations 
          to facilitate informed decision-making and sustainable development outcomes 
          across public, private, and non-profit sectors.
        </p>
      </div>

    </section>
  );
}
